<template>
  <base-dialog
  ref="base"
  v-model="model"
  width="500"
  :title="$t(`dialogs.titles.${preview ? 'previewFiles' : 'attachFiles'}`)"
  header-bg="blue"
  @open="cloneAttachments"
  :override-close-dialog="closeDialog"
  :exitable="!canSave">
    <div>
      <select-attachments-list
      class="mt-4"
      :attachments.sync="attachmentsProps"
      :max="10"
      :max-size="50"
      unit="MB"
      :disabled="preview || isLoading"/>
      <div
      v-if="canSave"
      class="d-flex justify-space-around mt-6">
        <outlined-btn
        @click="tryToSave"
        :label="$t('btns.save')"
        :height="35"
        :loading="isLoading"/>
        <outlined-btn
        @click="closeDialog"
        :label="$t('btns.cancel')"
        color="#ff3547"
        :height="35"
        :loading="isLoading"/>
      </div>
    </div>
  </base-dialog>
</template>
<script>
import BaseDialog from '@/components/dialogs/BaseDialog'
import SelectAttachmentsList from '@/components/lists/dynamic/SelectAttachmentsList'
import OutlinedBtn from '@/components/btns/OutlinedBtn'
import { copyObj } from "@/utils/StringUtil"
import { wait } from "@/utils/threads"
export default {
  components: {
    BaseDialog,
    SelectAttachmentsList,
    OutlinedBtn
  },
  props: {
    value: Boolean,
    attachments: {
      type: Array,
      required: true
    },
    preview: {
      type: Boolean,
      default: false
    },
    onSave: {
      type: Function,
      required: true
    }
  },
  model: {
    prop: 'value',
    event: 'valueChanged'
  },
  data() {
    return {
      isLoading: false,
      currentAttachments: []
    }
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit('valueChanged', v)
      }
    },
    attachmentsProps: {
      get: function() {
        return this.$props.attachments
      },
      set: function(v) {
        this.$emit('update:attachments', v)
      }
    },
    canSave() {
      if (this.preview) return false

      const NEW_IDS = this.attachmentsProps.map((o, i) => o.id || i)
      const OLD_IDS = this.currentAttachments.map((o) => o.id)
      if (OLD_IDS.length !== NEW_IDS.length) return true

      for (const ni of NEW_IDS) {
        if (!OLD_IDS.includes(ni)) return true
      }

      return false
    }
  },
  methods: {
    async tryToSave() {
      try {
        this.isLoading = true
        await wait(100)
        await this.onSave()
        await wait(100)
        this.closeDialog(false)
      }
      finally {
        this.isLoading = false
      }
    },
    cloneAttachments() {
      this.currentAttachments = [...this.attachmentsProps.map((o) => copyObj(o))]
    },
    rollbackAttachments() {
      if (!this.canSave) return
      this.attachmentsProps = [...this.currentAttachments]
    },
    closeDialog(rollback=true) {
      if (rollback) this.rollbackAttachments()
      this.model = false
    }
  }
}
</script>
<style>

</style>